import { parseBigInt, toBigInt32, } from "@shared";
const noScope = { kind: "none" };
function qs(ctx) {
    return new URLSearchParams(ctx.querystring);
}
export function adminRoute(_ctx) {
    return {
        kind: "admin_route",
        scope: noScope,
    };
}
export function profileSummaryRoute(_ctx) {
    return {
        kind: "profile_summary_route",
        scope: noScope,
    };
}
export function welcomeRoute(_ctx) {
    return {
        kind: "welcome_route",
        scope: noScope,
    };
}
const TOKEN_ACTIONS = ["send", "receive", "swap"];
// /wallet/:segment? where the segment is a view (send, receive …) or a token's ledger id
export function walletRoute(ctx) {
    const segment = ctx.params.segment;
    if (segment === undefined || segment === "") {
        return { kind: "wallet_route", scope: noScope, view: "all" };
    }
    if (segment === "recipients") {
        return { kind: "wallet_route", scope: noScope, view: "recipients" };
    }
    const action = TOKEN_ACTIONS.find((a) => a === segment);
    if (action !== undefined) {
        return {
            kind: "wallet_route",
            scope: noScope,
            view: action,
            ledger: qs(ctx).get("token") ?? undefined,
        };
    }
    return { kind: "wallet_route", scope: noScope, view: "token", ledger: segment };
}
export function notificationsRoute(_ctx) {
    return {
        kind: "notifications_route",
        scope: noScope,
    };
}
export function communitesRoute(_ctx) {
    return {
        kind: "communities_route",
        scope: noScope,
    };
}
export function shareRoute(ctx) {
    const $qs = qs(ctx);
    return {
        kind: "share_route",
        title: $qs.get("title") ?? "",
        text: $qs.get("text") ?? "",
        url: $qs.get("url") ?? "",
        scope: noScope,
    };
}
export function blogRoute(ctx) {
    return {
        kind: "blog_route",
        slug: ctx.params["slug"],
        scope: noScope,
    };
}
export function chatListRoute(scope) {
    return (_ctx) => {
        return {
            kind: "chat_list_route",
            scope,
        };
    };
}
export function globalDirectChatSelectedRoute(scope) {
    return (ctx) => {
        return chatSelectedRoute(ctx, "direct_chat", scope);
    };
}
export function globalGroupChatSelectedRoute(scope) {
    return (ctx) => {
        return chatSelectedRoute(ctx, "group_chat", scope);
    };
}
function createCommunityIdentifier(id) {
    return { kind: "community", communityId: id };
}
export function selectedCommunityRoute(ctx) {
    return {
        kind: "selected_community_route",
        communityId: { kind: "community", communityId: ctx.params["communityId"] },
        scope: { kind: "community", id: createCommunityIdentifier(ctx.params["communityId"]) },
    };
}
export function routeForScope(scope) {
    switch (scope.kind) {
        case "community":
            return `/community/${scope.id.communityId}`;
        case "chats":
            return "/chats";
        case "favourite":
            return "/favourite";
        default:
            return "/";
    }
}
export function selectedChannelRoute(fav) {
    return (ctx) => {
        // A channel id that isn't an integer (e.g. a domain pasted into the URL) would make
        // BigInt throw during routing, so show the community instead
        const channelId = parseBigInt(ctx.params["channelId"]);
        if (channelId === undefined) {
            return selectedCommunityRoute(ctx);
        }
        const $qs = qs(ctx);
        return {
            kind: "selected_channel_route",
            chatId: {
                kind: "channel",
                communityId: ctx.params["communityId"],
                channelId: Number(toBigInt32(channelId)),
            },
            communityId: { kind: "community", communityId: ctx.params["communityId"] },
            messageIndex: ctx.params["messageIndex"]
                ? Number(ctx.params["messageIndex"])
                : undefined,
            threadMessageIndex: ctx.params["threadMessageIndex"]
                ? Number(ctx.params["threadMessageIndex"])
                : undefined,
            open: $qs.get("open") === "true",
            scope: fav
                ? {
                    kind: "favourite",
                }
                : { kind: "community", id: createCommunityIdentifier(ctx.params["communityId"]) },
        };
    };
}
export function favouritesRoute(ctx) {
    const $qs = qs(ctx);
    return {
        kind: "favourites_route",
        chatId: ctx.params["chatId"] || undefined,
        messageIndex: ctx.params["messageIndex"] ? Number(ctx.params["messageIndex"]) : undefined,
        threadMessageIndex: ctx.params["threadMessageIndex"]
            ? Number(ctx.params["threadMessageIndex"])
            : undefined,
        open: $qs.get("open") === "true",
        scope: { kind: "favourite" },
    };
}
function chatSelectedRoute(ctx, chatType, scope) {
    const $qs = qs(ctx);
    const chatId = ctx.params["chatId"] || undefined;
    if (chatId === undefined) {
        return {
            kind: "home_route",
            scope,
        };
    }
    const identifier = chatType === "direct_chat"
        ? { kind: "direct_chat", userId: chatId }
        : { kind: "group_chat", groupId: chatId };
    return {
        kind: "global_chat_selected_route",
        chatId: identifier,
        chatType,
        messageIndex: ctx.params["messageIndex"] ? Number(ctx.params["messageIndex"]) : undefined,
        threadMessageIndex: ctx.params["threadMessageIndex"]
            ? Number(ctx.params["threadMessageIndex"])
            : undefined,
        open: $qs.get("open") === "true",
        scope,
    };
}
export function chatTypeToPath(chatType) {
    return chatType === "direct_chat" ? "user" : "group";
}
